import React, { useState, useEffect, useRef } from 'react';
import { Link, withRouter } from 'react-router-dom';
import HeaderJson from './header.json';
import './header.css';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from "../../redux/actions/login";
import ApiTrans from '../../services/trans/trans';
let apiTrans = new ApiTrans();

const Header = (props) => {
    const [menuHide, setMenuHide] = useState(false);
    const [menu, setMenu] = useState([]) //scrollMenu
    const [activeMenu, setActiveMenu] = useState('');//filter menu
    const [activeHeader, setActiveHeader] = useState('');
    const [headerHeight, setHeaderHeight] = useState(0);//header height

    const [loggedIn, setLoggedIn] = useState(false)

    let dispatch = useDispatch();

    const updateLoginFlag = (flag) => {
        setLoggedIn(flag)
    }

    const logoutClick = () => {
        dispatch(logout())
    }

    useEffect(() => {
        let sethHeight = document.getElementById('header_height').clientHeight;
        setHeaderHeight(sethHeight)
        setMenu(HeaderJson)

        apiTrans.checkCookies({}).then((res, index) => {
            if (res?.data?.code === 401) {
                updateLoginFlag(false);
            } else {
                updateLoginFlag(true);
            }
        })

    }, [])
    const ShowMenuClick = (data) => {
        if (data === activeHeader) {
            setActiveHeader("")
        } else {
            setActiveHeader(data)
        }

    }

    useEffect(() => {
        // setMenuHide(false)
    }, [])
    const childMenu = () => {
        setMenuHide(false)
    }
    const menuClick = () => {
        if (menuHide) {
            setMenuHide(false)
        } else {
            setMenuHide(true)
        }
    }
    const headerHide = () => {
        setMenuHide(false)
        setActiveMenu('');
        setActiveHeader('');
        // sujeet
    }
    //console.log(HeaderJson, 'HeaderJosn')

    // useEffect(() => {
    //     window.addEventListener('scroll', headerfixed)
    //     if (!menuHide) {
    //         setActiveMenu('')
    //     }
    // },[])

    const headerfixed = (event) => {


        // let sethHeight = document.getElementById('header_height').offsetHeight;
        // console.log(sethHeight, 'sethHeight')
        let sethHeight = document.getElementById('header_height').clientHeight;
        if (sethHeight !== null) {
            let getScroll = window.scrollY;
            let numscroll = sethHeight - getScroll;
            if (numscroll >= 0) {
                //console.log(numscroll, 'if')
                setHeaderHeight(numscroll)
            } else {
                let numscroll1 = numscroll < 0 ? 0 : numscroll
                setHeaderHeight(numscroll1)
            }
        }


        // console.log(numscroll, 'header', getScroll,)

    }

    const filterClick = (data) => {
        setActiveMenu(data)
        if (data === "HOME") {
            setMenu(HeaderJson)
            // setActiveMenu('')
            return true;
        }
        let Arraymenu = [];
        if (!menuHide) {
            setMenuHide(true)
        }

        let getHeader = HeaderJson;
        // console.log('data==', data)
        getHeader.map((curr, index) => {
            //console.log(curr, 'curr')
            let innerArray = [];
            if (curr.filter === data) {
                Arraymenu.push(curr)
            }
            if (curr.filter === "all") {
                Arraymenu.push(curr)
            }
            // console.log(innerArray, 'innerArray')

            //Arraymenu = innerArray

        })
        // console.log(Arraymenu, 'Arraymenu')
        setMenu(Arraymenu)
    }

    return (
        <React.Fragment>
            <div className="header_main clearfix" id="header_height">
                <div className="header_top header_padd col-md-12 col-12">
                    <div className="row">
                        <div className="col-md-4 col-6 mobilelogoPadd">
                            <Link to="/">
                                <img src={require('./images/logo.png').default} className="img-fluid" alt="images" />
                            </Link>
                        </div>
                        <div className="col-md-8 col-6">
                            <ul className="header_top_menu">
                                <li>
                                    {/* <div className="s_icon"></div> */}
                                </li>
                                <li>
                                    <div className="notify_icon">
                                        <span>5</span>
                                    </div>
                                </li>
                                {loggedIn ?
                                    <>
                                        <>
                                            {props.path === "/confirmation" || props.path === "/sessionExpired" ?
                                                null
                                                :
                                                <li>
                                                    <button type="button" onClick={logoutClick} className="login_btn">
                                                        <span className="d-none d-sm-block">Logout</span>
                                                        <span className="d-block d-sm-none"></span>
                                                    </button>
                                                </li>
                                            }
                                        </>
                                    </>
                                    :
                                    <>
                                        <li>
                                            <button type="button" onClick={() => { props.history.push('/login') }} className="login_btn">
                                                <span className="d-none d-sm-block">Login</span>
                                                <span className="d-block d-sm-none"></span>
                                            </button>
                                        </li>
                                    </>
                                }
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="header_bottom header_padd top_padd0 col-md-12">
                    <span className="bar_bar_m" onClick={menuClick}></span>
                    <div className="menu_name">
                        <ul className="header_bottom_ul">
                            {/* <li
                                onClick={() => filterClick('HOME')} className={`${activeMenu === "HOME" ? "active" : ""}`} >
                                <img src={require('./images/home.png')} alt="images" /></li>
                            
                            <li> */}
                            <li> <Link to="/">
                                <img src={require('./images/home.png').default} alt="images" />
                            </Link>
                            </li>

                            <li>

                                <Link to="/mf">Mutual fund</Link>
                            </li>

                            <li>

                                <Link to="/mf/ourfunds">Schemes</Link>
                            </li>
                            <li>
                                <Link to="/nav">NAV &amp; Dividend</Link>
                            </li>
                            <li>
                                <Link to="/Download/mutualfund/totalExpense">Download</Link>
                            </li>

                            {/* <li>
                                <Link to="#">Investor Education</Link>
                            </li> */}
                            <li>
                                <Link to="/tools/sip-return-calculator">Tools</Link>
                            </li>
                            <li >
                                <Link to="/Contact">Contact US</Link>
                            </li>
                            {/* <li>
                                <Link to="/mf/category">F</Link>
                            </li> */}
                            {/* <li>
                                <Link to="/PassiveFund">Passive</Link>
                            </li> */}
                            {/* <li>
                                <Link to="/mf/PMS">PMS</Link>
                            </li> */}

                            {/* <li>
                                <Link to="/InternationalBusiness">International Business</Link>
                            </li> */}

                            <li>
                                <Link to="/about-us/Overview">About us </Link>
                            </li>
                            {/* <li onClick={() => filterClick('MF')} className={`${activeMenu === "MF" ? "active" : ""}`} >MF</li>
                            <li onClick={() => filterClick('PMS')} className={`${activeMenu === "PMS" ? "active" : ""}`} >PMS</li>
                            <li onClick={() => filterClick('PASSIVE')} className={`${activeMenu === "PASSIVE" ? "active" : ""}`}>PASSIVE FUND</li>
                            <li onClick={() => filterClick('ETF')} className={`${activeMenu === "ETF" ? "active" : ""}`} >ETF</li>
                            <li onClick={() => filterClick('AIF')} className={`${activeMenu === "AIF" ? "active" : ""}`} >AIF</li>
                            <li onClick={() => filterClick('DISTRIBUTOR')} className={`${activeMenu === "DISTRIBUTOR" ? "active" : ""}`} >DISTRIBUTOR PLATFORM</li> */}
                        </ul>
                    </div>

                </div>
            </div>
            {menuHide ?
                <div className="headerOverlay" onClick={headerHide}></div> : null}
            <div className={`slideMenu ${menuHide ? 'slideMenu_active' : ""}`} style={{ top: headerHeight }}>
                <ul className="scroll_menu_list">
                    {menu.map((curr, index) => {
                        //console.log(curr, 'curr')
                        return (
                            <li key={index}>
                                {curr.Children.length > 0 ?
                                    <p onClick={() => ShowMenuClick(curr.Heading)} className={`${curr.Heading === activeHeader ? "Active_hightlight" : ""}`}>
                                        <span className={`${curr.class} hbg_left`}></span>
                                        {curr.Heading} <span className="hmfdownArrow"><img src={require('./images/downarrow.png').default} /></span></p> :
                                    <Link onClick={childMenu} to={curr.url} className={`${curr.Heading === activeHeader ? "Active_hightlight" : ""}`}>
                                        <span className={`${curr.class} hbg_left`}></span>
                                        {curr.Heading} </Link>
                                }

                                {curr.Children.length > 0 ?
                                    <div className={`inner_body ${activeHeader === curr.Heading ? "inner_body_active" : ""}`}>
                                        {curr.Children.map((currData, index) => {
                                            return (
                                                <Link onClick={childMenu} to={currData.url} key={currData + index}> - {currData.Label} </Link>
                                            )
                                        })}

                                        {/* <Link to="#">MF HOME PAGE</Link>
                                    <Link to="#">MF HOME PAGE</Link> */}
                                    </div> : null
                                }

                            </li>
                        )
                    })}
                    {/* <li>
                        <p>
                            <span className="hmfBg hbg_left"></span>
                            Mutual Fund <span className="hmfdownArrow"><img src={require('./images/downarrow.png')} /></span></p>
                        <div className="inner_body">
                            <Link to="#">MF HOME PAGE</Link>
                            <Link to="#">MF HOME PAGE</Link>
                            <Link to="#">MF HOME PAGE</Link>
                        </div>
                    </li>
                    <li>
                        <p>Mutual Fund</p>
                    </li>
                    <li>
                        <p>Mutual Fund</p>
                    </li> */}
                </ul>
            </div>
            <div style={{ clear: "both" }}></div>
        </React.Fragment >
    )
}

export default withRouter(Header)